  import React, { useEffect, useState } from 'react';
  import '../../css/ClienteLanding.css'; 
  import Swal from 'sweetalert2';
  import { useIsAuthenticated } from "@azure/msal-react";
  import { Carousel } from 'react-bootstrap';
  import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
  import TerminosDelSorteo from '../TokenModal/TerminosDelSorteo';
  import ModalConfirmacionExitosa from '../TokenModal/ModalConfirmacionExitosa';
  import TokenModal from '../TokenModal/ModalTokenCliente';
  import Footer from '../../components/Footer/footer';
  import Operador from '../../components/Operador/operador';
  import { CONSTANTES } from '../../config/constantaes';
  import { createCLientes } from "../../Services/clientes.services"
  import { enviarSms, enviarSmsToken } from "../../Services/sms.services"
  import { useContext } from "react";
  import { UtmContext } from "../../context/UtmContext";
  import iconParticipando from "../../assets/img/icon.svg";
  
   const ClienteLanding = () => {
        const isAuthenticated = useIsAuthenticated();
        const [errorCorreo, setErrorCorreo] = useState(null);
        const [loading, setLoading] = useState(false);
        const [, setMostrarMensajePolitica] = useState(false);
        const [consentimiento1Habilitado, setConsentimiento1Habilitado] = useState(false);
        const { executeRecaptcha } = useGoogleReCaptcha();
        const [submitted, setSubmitted] = useState(false);
        const [index, setIndex] = useState(0); //slide activo
        const [showModalConfirmacionExitosa, setShowModalConfirmacionExitosa] = useState(false);
        const [showTokenModal, setShowTokenModal] = useState(false);
        const [, setBackendError] = useState(null);
        const utmData = useContext(UtmContext);

       function generarCodigoCliente(dni) {
          if (!dni || dni.length !== 8) return "";
          return `CL-${dni}`;
        }
        const [formData, setFormData] = useState({
          dni: '',
          telefono: '',
          correo: '',
          operadorId: '',
          codigoCliente: '',
          consentimiento1: 0,
          consentimiento2: 0,
          captcha:''
        });

        useEffect(() => {
          if (formData.dni?.length === 8) {
            const codigo = `CL-${formData.dni}`;

            setFormData(prev => {
              if (prev.codigoCliente === codigo) return prev;

              return {
                ...prev,
                codigoCliente: codigo
              };
            });
          }
        }, [formData.dni]);

      const handleContinuarRegistro = async () => {

        if (loading) return; // evita doble ejecución

        if (!executeRecaptcha) {
          await Swal.fire({
            title: 'Error',
            text: 'Captcha no disponible.',
            icon: 'error'
          });
          return;
        }

        if (!formData.codigoCliente) {
          await Swal.fire({
            title: 'Error',
            text: 'No se pudo generar el código del cliente.',
            icon: 'error'
          });
          return;
        }

        try {
          setLoading(true); // AQUÍ empieza el loading real

          const captchaToken = await executeRecaptcha('registro');

          const clientePayload = {
            ...formData,
            operadorId: formData.operadorId,
            consentimiento1: "1",
            consentimiento2: "1",
            captcha: captchaToken,
            URL_UTM: utmData?.URL_UTM || "",
            UTM_SOURCE: utmData?.UTM_SOURCE || "",
            UTM_MEDIUM: utmData?.UTM_MEDIUM || "",
            UTM_CAMPAIGN: utmData?.UTM_CAMPAIGN || "",
            UTM_TERM: utmData?.UTM_TERM || "",
            UTM_CONTENT: utmData?.UTM_CONTENT || ""
          };

          const response = await createCLientes(clientePayload);

          if (!response) {
            await Swal.fire({
              title: 'Error',
              text: 'No se recibió respuesta del servidor.',
              icon: 'error'
            });
            return;
          }

          if (!response.success) {

            if (response.code === "409") {
               await Swal.fire({
                  html: `
                    <div style="text-align:center; padding:10px 20px;">
                      
                      <img 
                        src="${iconParticipando}" 
                        alt="icon" 
                        style="width:70px; margin-bottom:15px;"
                      />

                      <h2 style="
                        color:#fa4616;
                        font-weight:700;
                        margin-bottom:10px;
                      ">
                        Ya estás participando
                      </h2>

                      <p style="
                        font-size:14px;
                        color:#555;
                        line-height:1.5;
                      ">
                        Este DNI ya cuenta con una inscripción.<br/>
                        <span style="color:#8f1a95; font-weight:600;">
                          Puedes intentarlo nuevamente en el siguiente mes.
                        </span>
                      </p>

                    </div>
                  `,
                  showConfirmButton: true,
                  confirmButtonText: '¡Entendido!',
                  confirmButtonColor: '#fa4616',
                  customClass: {
                    popup: 'swal2-border-radius'
                  }
                });

              limpiarFormulario();
              return;
            }

            await Swal.fire({
              title: 'Oops..',
              text: response.message || "Ocurrió un error.",
              icon: 'error'
            });

            limpiarFormulario();
            return;
          }

          // ÉXITO
          setShowModalConfirmacionExitosa(true);

          try {
            await enviarSms({
              cellPhone: formData.telefono,
              message: "",
              senderId: "ALFIN",
              email: formData.correo,
              operadorId: formData.operadorId
            });
          } catch (e) {
            console.error("Error enviando SMS:", e);
          }

          setTimeout(() => limpiarFormulario(), 300);

        } catch (error) {

          console.error("Error real:", error);

          const errorMessage =
            error?.response?.data?.message ||
            error?.message ||
            "Error de conexión con el servidor.";

          await Swal.fire({
            title: 'Error',
            text: errorMessage,
            icon: 'error'
          });

          limpiarFormulario();

        } finally {
          setLoading(false); // SIEMPRE se apaga
        }
      };

        const cerrarModal = () => {
          setShowModalConfirmacionExitosa(false);
        };
        
        useEffect(() => {
          const correoValido =
            formData.correo &&
            /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.correo);

          if (correoValido) {
            const timer = setTimeout(() => {
              setConsentimiento1Habilitado(true);
            }, 2000);

            return () => clearTimeout(timer);
          } else {
            setConsentimiento1Habilitado(false);
          }
        }, [formData.correo]);

       
        const handleSelect = (selectedIndex, e) => {
          setIndex(selectedIndex);
        };
        
         // Validación del correo
        const validarCorreo = (email) => {
         email = email.trim().toLowerCase();
            
            // Regex mejorado (permite más caracteres válidos y dominios internacionales)
            const emailRegex = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i;
            
            if (!emailRegex.test(email)) {
              return "Ingrese un correo válido.";
            } 

            if (email.includes("..")) {
              return "El correo no puede contener puntos consecutivos.";
            } 

            // Ya no validamos dominios permitidos, acepta cualquier dominio válido
            return null;
          }

        const handleCorreoChange = (e) => {
          const { value } = e.target;
          setFormData(prev => ({ ...prev, correo: value }));
           
          const error = validarCorreo(value);
          setErrorCorreo(error);

            // Si es un correo válido iniciamos el temporizador
          if (!error) {
            setMostrarMensajePolitica(true);
            setConsentimiento1Habilitado(false); // Lo desactivamos temporalmente

            setTimeout(() => {
            setConsentimiento1Habilitado(true);
              setMostrarMensajePolitica(false);
          }, 3000);
          } else {
            setMostrarMensajePolitica(false);
            setConsentimiento1Habilitado(false);
          }
        };

        const handleInputChange = (e) => {
          const { name, value, type, checked } = e.target;

          if (name === "correo") {
            const error = validarCorreo(value);
            setErrorCorreo(error);
          }

          setFormData(prev => ({
            ...prev,
            [name]:
              name === "operadorId"
                ? (value ? parseInt(value) : "")
                : (type === 'checkbox' ? checked : value)
          }));
       
        };

        const limpiarFormulario = () => {
          setFormData({
            dni: '',
            telefono: '',
            correo: '',
            operadorId:'',
            consentimiento1: 0,
            consentimiento2: 0
          });
     
          setConsentimiento1Habilitado(false); // <-- Muy importante, bloquea nuevamente el checkbox
          setMostrarMensajePolitica(false);   // <-- También resetea el mensaje
          setErrorCorreo(null); // limpia los posibles errores de correo  
          setSubmitted(false); //esto limpia los mensajes de error        
        };
        
        const handleSubmit = async (e) => {
            e.preventDefault();
            setSubmitted(true);

            if (!formData.consentimiento2) {
              Swal.fire({
                title: 'Consentimiento requerido',
                text: 'Debes aceptar la política de privacidad para continuar.',
                icon: 'info'
              });
              return;
            }
            try {
              setLoading(true);

              //PASO 1: ENVIAR OTP
              await enviarSmsToken({
                operadorId: formData.operadorId,
                celular: formData.telefono,
                correo: formData.correo,
                nombre: formData.dni
              });

              //PASO 2: ABRIR MODAL TOKEN
                setShowTokenModal(true);

            } catch (error) {
                Swal.fire({
                  title: 'Error',
                  text: 'No se pudo enviar el código.',
                  icon: 'error'
                });
            } finally {
              setLoading(false);
            }
        };
       
        //Validación del token
        // const handleTokenValidado = (validado) => {
        //   if (validado) {
        //     setShowTokenModal(false);
        //     setShowModalValidacionExitosa(true);
        //   }
        // };

        //Validación del token
        const handleTokenValidado = async (validado) => {
          if (validado) {
            setShowTokenModal(false);
     
            //FLUJO DIRECTO
            await handleContinuarRegistro();
          }
        };

        //Logica para BITEL
          const OPERADOR_BITEL = 3;
          const esBitel = formData.operadorId === OPERADOR_BITEL;

      if (!isAuthenticated) {
      return (
        <div className="container-fluid p-0">       
            <header className="custom-header py-3 px-4 d-flex align-items-center">
              <a
                href="https://www.alfinbanco.pe/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="https://i0.wp.com/www.alfincontacto.pe/wp-content/uploads/2024/06/ALFIN-CONTACTO.png?w=920&ssl=1"
                  alt="Alfin Banco"
                  height="80px"
                />
              </a>
            </header>      
             <div
              style={{
                background: 'linear-gradient(90deg, #8f1a95 0%, #fa4616 100%)',
                color: '#fff',
                textAlign: 'center',
                padding: '10px 0',
                fontWeight: 'bold',
                letterSpacing: '0.5px',
                fontSize: '18px',
                boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
                position: 'sticky',
                top: 0,
                zIndex: 999,
                animation: 'pulse 2s infinite'
              }}
            >
              <span role="img" aria-label="gift">🎁</span> 
              <span style={{ marginLeft: '8px' }}>Próximo sorteo: <strong>{CONSTANTES.FECHA_CAMPANIA}</strong></span>
            </div>
            
            <div className="row flex-column flex-md-row p-3 align-items-stretch main-content">
              <div className='col-md-6 d-flex flex-column align-items-center mb-4 mb-md-0 custom-background movil-contenedor' style={{ position: 'relative' }}>
                <h2 className="carousel-title" style={{ fontSize: '46px', fontWeight: 'bold', textAlign: 'center' }}>
                                    <span style={{ color: '#fa4616' }}>¡Alfin te </span>
                                    <span style={{ color: '#8f1a95' }}>premia!</span>
                </h2>
                <Carousel activeIndex={index}
                  onSelect={handleSelect}  controls={false} 
                  indicators={false} fade interval={2000}
                  style={{ width: '305px', height: '304px', overflow: 'hidden', position: 'relative'}}>
                     {[1, 2, 3].map(num => (
                        <Carousel.Item key={num} style={{ height: '354px' }}>
                          <img 
                            className="d-block w-100 img-fluid"
                            src={require(`../../assets/img/${num}-min.png`)}
                            alt={`Banner ${num}`}
                            style={{ objectFit: 'cover', width: '305px' }}
                          />
                        </Carousel.Item>
                    ))} 
                   

                </Carousel>
                {index !== 5 && (
                <div className="col-md-10 d-flex flex-column align-items-center auspiciado-movil" style={{marginTop:'35px'}}>
                  <img src={require('../../assets/img/auspiciado-por.png')}
                    alt="Cliente registrándose"
                    className="img-fluid rounded mb-4 border-movil"
                  />
                </div>
                )}
              </div>

            <div className="col-md-6 h-100">
                  <form onSubmit={handleSubmit} className="p-4 shadow rounded bg-white h-100 d-flex flex-column justify-content-between" style={{minHeight: '655  px'}}>
                    <h1 className='tituloCliente'>
                      ¡Tu chance de ganar empieza aquí! 
                      <br/><strong>Regístrate y participa</strong>
                    </h1>
                    <div className="mb-3" style={{color:'#cecdc9', marginTop:'50px'}}>
                        <input 
                          name="dni" type="text" className="form-control"
                          placeholder="Tu número de DNI aquí" pattern="\d{8}"
                          title="Debe contener exactamente 8 dígitos"
                          value={formData.dni}
                          maxLength="8" required
                          onChange={(e) => {
                          const onlyNums = e.target.value.replace(/\D/g, '');
                            setFormData({ ...formData, dni: onlyNums });
                            }}
                        />
                        {submitted && formData.dni.trim() == '' && (
                          <small style={{ color: '#ff3c00' }}>Este dato es necesario para continuar.</small>
                        )}
                        {formData.dni.length > 0 && formData.dni.length !== 8 && (
                          <small style={{ color: '#ff3c00' }}>El DNI debe tener 8 dígitos.</small>
                        )}
                    </div>    
                    <div className="mb-3 row g-2">
                      <div className="col-4">
                        <Operador
                          value={formData.operadorId}
                          onChange={handleInputChange}
                          disabled={formData.dni.length !== 8}
                        />
                      </div>
                      <div className="col-8">
                        <input name="telefono" type="text"
                        className="form-control" placeholder="Tu número de celular aquí"
                        pattern="\d{9}" title="Debe contener exactamente 9 dígitos"
                        value={formData.telefono}
                        maxLength="9" required
                        onChange={(e) => {
                        const onlyNums = e.target.value.replace(/\D/g, '');
                        setFormData({ ...formData, telefono: onlyNums });
                        }}
                        disabled={formData.dni.length !== 8} 
                      />
                      </div>
                      {submitted && formData.telefono.trim() == '' && (
                        <small style={{ color: '#ff3c00' }}>Este dato es necesario para continuar.</small>
                      )}
                      {formData.telefono.length > 0 && formData.telefono.length !== 9 && (
                        <small style={{ color: '#ff3c00' }}>El celular debe tener 9 dígitos.</small>
                      )}
                      {formData.telefono.length === 9 && !formData.telefono.startsWith('9') && (
                        <small style={{ color: '#ff3c00' }}>
                          Celular no consistente (debe empezar con 9).
                        </small>
                      )}
                    </div>
                    <div className="mb-3">
                      <input name="correo"
                        type="email" className="form-control"
                        placeholder="Tu correo electrónico aquí" 
                        value={formData.correo}
                        title="Ingresa un correo válido" required
                        onChange={ handleCorreoChange }
                        disabled={formData.telefono.length !== 9}
                      />
                      {submitted && formData.correo.trim() == '' && (
                        <small style={{ color: '#ff3c00' }}>Este dato es necesario para continuar.</small>
                      )}
                      {errorCorreo && (
                        <small style={{ color: '#ff3c00' }}>{errorCorreo}</small>
                      )}
                       {/*MENSAJE SOLO PARA BITEL */}
                      {esBitel && (
                        <div className="mensaje-bitel">
                          Recuerda colocar un <strong>correo válido</strong> al cuál enviaremos un código de 4 dígitos para poder <strong>continuar el proceso</strong>.
                        </div>
                      )}
                    </div>
                    <div className="alfin-column-100">
                        <div className="form-check" style={{marginTop: '20px'}}>
                          <input className="form-check-input" 
                            type="checkbox"
                            name="consentimiento2"
                            id="promoCheck"
                            checked={formData.consentimiento2}
                            onChange={handleInputChange}
                            disabled={!consentimiento1Habilitado}
                          />
                            <label className="form-check-label" htmlFor="promoCheck" style={{ display: 'block' }}>
                              <span style={{ color: '#6e7881' }}>He leído y otorgo mi </span>
                              <a
                                target="_blank"
                                rel="noreferrer"
                                href="https://www.alfinbanco.pe/promociones-con-fines-comerciales"
                                style={{ color: '#f44336' }}
                              >
                                Consentimiento para el Tratamiento de mis datos personales con finalidades comerciales
                              </a>{' '}
                              <span style={{ color: '#660099', fontWeight: 700 }}>
                                *Obligatorio
                              </span>
                            </label>
                        </div>
                       
                    </div>
                    <div className="captcha-and-button-wrapper">
                        <div className="elementor-button-wrapper" >
                          <button type="submit" 
                              className="btn custom-btn d-flex align-items-center gap-6" 
                              disabled={loading || !formData.consentimiento2}
                          >
                              {loading ? 'Enviando...' : (
                                <>
                                  <svg
                                    aria-hidden="true"
                                    className="e-font-icon-svg e-fas-file-export"
                                    viewBox="0 0 576 512"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="20">
                                    <path
                                      d="M384 121.9c0-6.3-2.5-12.4-7-16.9L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128zM571 308l-95.7-96.4c-10.1-10.1-27.4-3-27.4 11.3V288h-64v64h64v65.2c0 14.3 17.3 21.4 27.4 11.3L571 332c6.6-6.6 6.6-17.4 0-24zm-379 28v-32c0-8.8 7.2-16 16-16h176V160H248c-13.2 0-24-10.8-24-24V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V352H208c-8.8 0-16-7.2-16-16z"
                                      fill="currentColor" />
                                    </svg>                              
                                    <span className="elementor-button-text">Enviar y Participar</span>
                                </>
                              )}
                          </button>
                        
                        </div> 
                        <p style={{fontSize: '12px', marginTop: '20px', textAlign: 'center'}}>Conoce como ejercer tus derechos ARCO <a target='_blank' href='https://abancodigital.atlassian.net/servicedesk/customer/portal/57/group/111/create/409'>aqui</a></p>
                    </div>

                  </form>
                  <TokenModal
                        show={showTokenModal}
                        celular={formData.telefono}
                        correo={formData.correo}
                        operadorId={formData.operadorId}
                        onClose={() => setShowTokenModal(false)}
                        onTokenValidado={handleTokenValidado}
                  />
                  
                  {/* <ModalValidacionExitosa
                    show={showModalValidacionExitosa}
                    onContinuar={handleContinuarRegistro}
                  /> */}
                  {/* Aquí renderizamos el modal de confirmación */}
                  <ModalConfirmacionExitosa 
                    show={showModalConfirmacionExitosa} 
                    onClose={cerrarModal}
                  />
            </div>
            </div>
          <div className='d-flex legal-container_ejemplo align-items-center'>
            <div style={{ fontSize: '11px', textAlign: 'justify', color: '#a09ea0', width: '100%'}}>
                  <TerminosDelSorteo />
            </div>
          </div>
          
            <Footer/>
        
        </div>
      );
  }

      
      

  };
  export default ClienteLanding;